<template>
     <div class="businessopportunityopen-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Open Business Opportunity" 
                />
          <b-card class="businessopportunityopen-search-card">
                    <b-tabs card vertical >
                        <b-tab title="Business Opportunity" active>
                        <b-form>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="businessopportunityopens" 
                            :fields="fielsOpportunity">
                             <template v-slot:cell(actions)="data">
                                 <b-button 
                                    title="Open Property Image Gallery" 
                                    size="sm" 
                                    variant="light" 
                                    @click="openModalCarousel('immobilefilesbyid',data.item.immobile_id_opportunity)" 
                                    class="mr-2">
                                <i class="fa fa-file-image-o"></i>
                                </b-button>
                             </template>
                              <template v-slot:cell(actions1)="data">
                                 <b-button 
                                    title="Open Location Image Gallery" 
                                    size="sm" 
                                    variant="light" 
                                    @click="openModalCarousel('immobileitemfilesbyid',data.item.immobile_item_id_opportunity)" 
                                    class="mr-2">
                                <i class="fa fa-file-image-o"></i>
                                </b-button>
                             </template>

                        </b-table>
                        </transition>   
                                             
                            </b-row>
                        </b-form>

                        </b-tab >
                    </b-tabs>         
                </b-card>  
                  <b-modal
            id="modalCarouselImageOwner"
            hide-footer
            ref="modal"
            title-tag="h6"
            title="Image Gallery"
            size="lg"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <CarouselImage :objeto="objeto_local" :objeto_id="objeto_local_id" />
          </b-modal>   
     </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import CarouselImage from '../util/CarouselImage'

var moment = require('moment-timezone')

export default {
    name: 'BusinessOpportunityOpen',
    components: {PageTitle,CarouselImage },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                 objeto_local: '',
                objeto_local_id: null,
                businessopportunityopens:[],
                 isBusy: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
             
                fielsOpportunity:[
                      {
                        key: 'date_opportunity',label: 'Opportunity Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'address_immobile', label: 'Address', sortable: false ,variant: 'light'},
                     { key: 'actions', label: '...',variant: 'light' },
                    { key: 'name_type_part_immobile', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'description_item', label: 'Description', sortable: false ,variant: 'light'},
                     { key: 'actions1', label: '...',variant: 'light' },
                    { key: 'rent_payment_day_opportunity', label: 'Rent payment day', sortable: false ,variant: 'light'},
                    { key: 'pet_allowed_immobile', label: 'Pets Allowed', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' }, 
                    { key: 'value_opportunity', label: 'Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'percent_opportunity', label: '% Parther', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                     
                
                ]
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rowsFinancial() {
                return this.businessopportunityopens.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
                        formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadFinancialDetail(){
                const url = `${baseApiUrl}/businessopportunitysbycompanyopen/${this.compan.id}`
                axios(url).then(res =>{
                     this.businessopportunityopens = res.data
                })
            },
            openModalCarousel(objeto,objeto_id) {

                this.objeto_local = objeto
                this.objeto_local_id = objeto_id

                this.$bvModal.show('modalCarouselImageOwner')
            },


        },
        mounted(){
            this.loadFinancialDetail()
            this.showTable = true
        }
}
</script>

<style>


    .businessopportunityopen-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .businessopportunityopen-search button{
        font-size: 0.75rem;
    }

     .businessopportunityopen-search select{
        font-size: 0.75rem;
    }

    .businessopportunityopen-search input{
        font-size: 0.75rem;
    }

    .businessopportunityopen-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

 #modalFinancial {
        font-size: 0.75rem;
    }

    #modalFinancial button{
        font-size: 0.75rem;
    }

     #modalFinancial input{
        font-size: 0.75rem;
    }

      #modalFinancial select{
        font-size: 0.75rem;
    }

      #modalFinancial label{
        font-size: 0.75rem;
        color: black;
    }
    
       #modalFinancial textarea{
            font-size: 0.75rem;
        }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
